import { createContext, useContext } from 'react';
export const SampleContactContext = /*#__PURE__*/createContext(false);
export const useSampleContactContext = () => useContext(SampleContactContext);